var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsOptional, IsString, Matches, MaxLength } from 'class-validator';
/**
 * Body for `PATCH /office-location-datev-settings/:officeLocationId/konten-mapping`.
 *
 * Foldout 3 — "Konten-Mapping": every Konto in the mapping. All fields
 * are required: the resolver consumes a complete mapping, and shipping a
 * partial one would silently fall back to defaults for the missing keys.
 *
 * The exact numeric-string length is the responsibility of the domain entity,
 * which knows `sachkontenlaenge`: in v1 every Konto is a Sachkonto, so the
 * rule is `length === sachkontenlaenge` (NOT `+1` — see KontenMappingVo).
 * Since `sachkontenlaenge` is constrained to [4, 8], the DTO only validates
 * that each value is a numeric string in that 4–8 char window.
 */
export class UpdateKontenMappingDto {
    erloesSteuerfrei;
    erloese19;
    erloese7;
    sammeldebitorSelbstzahler;
    sammeldebitorPkv;
    forderungsverlustSteuerfrei;
    forderungsverlust7;
    forderungsverlust19;
    /**
     * Justification for changing a *frozen* settings block (PRD #1319 / RS-003).
     * Required by the domain once the first export has completed; ignored
     * before the freeze. Recorded verbatim into the change history.
     */
    reason;
}
__decorate([
    Matches(/^\d{4,8}$/, { message: 'erloesSteuerfrei must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "erloesSteuerfrei", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'erloese19 must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "erloese19", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'erloese7 must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "erloese7", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'sammeldebitorSelbstzahler must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "sammeldebitorSelbstzahler", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'sammeldebitorPkv must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "sammeldebitorPkv", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'forderungsverlustSteuerfrei must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "forderungsverlustSteuerfrei", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'forderungsverlust7 must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "forderungsverlust7", void 0);
__decorate([
    Matches(/^\d{4,8}$/, { message: 'forderungsverlust19 must be 4–8 digits' }),
    __metadata("design:type", String)
], UpdateKontenMappingDto.prototype, "forderungsverlust19", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(1000),
    __metadata("design:type", Object)
], UpdateKontenMappingDto.prototype, "reason", void 0);
//# sourceMappingURL=update-konten-mapping.dto.js.map